<template>
  <avue-crud ref="" :option="option" :data="data">
    <template slot="indexNumber" slot-scope="scope">
      <div>
        {{ scope.row.$index + 1 }}
      </div>
    </template>
    <template slot="amount" slot-scope="scope">
      <div>
        {{ getMoney(scope.row.amount) }}
      </div>
    </template>
    <template slot="interestAmount" slot-scope="scope">
      <div>
        {{ getMoney(scope.row.interestAmount) }}
      </div>
    </template>
  </avue-crud>
</template>

<script>

export default {
  name: "accessory",
  data() {
    return {
      option: {
        menuType: "button",
        menuWidth: 380,
        menuAlign: "center",
        align: "center",
        card: false,
        tip: false,
        lazy: false,
        tree: false,
        addBtn: false,
        editBtn: false,
        cellBtn: false,
        delBtn: false,
        selection: false,
        searchBtn: false,
        columnBtn: false,
        filterable: false,
        refreshBtn: false,
        menu: false,
        column: [
          {
            label: "序号",
            prop: "indexNumber",
            slot: true,
            width:60
          },
          {
            label: "日期",
            prop: "interestDate",
          },
          {
            label: "金额(元)",
            prop: "amount",
            slot: true,
          },

          {
            label: "当日费率",
            prop: "interestRate",
            type: "select",
            dicUrl: "/api/blade-/zd/interestrate/dictionary",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "当日使用费（元）",
            prop: "interestAmount",
            slot: true,
          },
          {
            label: "属性",
            prop: "loanStatus",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=loan_status",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
          },
        ],
      },

      isOnly: false,
      checkUserList: [],
      peopleName: "",
      personStatus: "",
      topicId: -1, //议题id,
      loading: false,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
 
  components: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.el-table {
  border: 1px solid #e2e2e2;
  border-right: none;
  border-bottom: none;
  th {
    background: #f2f2f2;
    color: #333;
  }
}
.action_block {
  display: flex;
  flex-direction: row;
  a {
    cursor: pointer;
    margin: 0 8px;
  }
}
.del_color {
  color: #409eff;
}
.member_list_wrapper {
  display: flex;
  flex-wrap: wrap;
}
.flex_wrp {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
</style>

